import { useState } from "react";
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styles from "./MultiActionButton.module.css";

interface ActionItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

interface MultiActionButtonProps {
  buttonLabel?: string;
  actions: ActionItem[];
}

const MultiActionButton: React.FC<MultiActionButtonProps> = ({
  buttonLabel = "Ações",
  actions,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleActionClick = (action: ActionItem) => {
    action.onClick();
    handleClose();
  };

  return (
    <div className={styles.container}>
      <Button
        variant="contained"
        endIcon={<MoreVertIcon />}
        onClick={handleOpen}
        className={styles.button}
      >
        {buttonLabel}
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {actions.map((action, index) => (
          <MenuItem
            key={index}
            onClick={() => handleActionClick(action)}
            className={styles.menu}
          >
            {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MultiActionButton;
